import classNames from 'classnames';
import { useMemo } from 'react';
import { CustomIcon } from '../custom-icon/custom-icon';
import styles from './empty-state.module.css';
import { AppLink } from '../app-link/app-link';

export interface EmptyStateProps {
    variant?: 'dynamic' | 'white';
    title: string;
    subtitle: string;
    actionLabel?: string;
    onPress?: () => void;
    icon?: 'plus-icon' | 'add-person' | 'heart-outline-icon' | 'search-outline-icon' | 'notification-bell-icon';
    noPadding?: boolean;
    hasBackground?: boolean;
    actionIcon?: 'plus-icon' | 'chevron-right-icon';
    href?: string;
    verticalMargins?: number;
}

export function EmptyState({ variant = 'dynamic', title, subtitle, actionLabel, onPress, icon = 'plus-icon', noPadding = false, hasBackground = true, actionIcon = 'plus-icon', href, verticalMargins }: EmptyStateProps) {
    const verticalMarginsStyle = useMemo(
        () =>
            verticalMargins ? {
                marginTop: `${verticalMargins}px`,
                marginBottom: `${verticalMargins}px`,
            } : {},
        [verticalMargins]
    );

    const renderCirclesIcon = () => {
        const circlesButton = () => {
            return (
                <button
                    type="button"
                    onClick={onPress}
                    className={classNames(styles['empty-state__circles-container'])}>
                    <CustomIcon type={icon} onClick={onPress} hasIconHover color={variant} />
                    <div className={classNames(styles['empty-state__circle'], styles['empty-state__circle-1'], styles[`empty-state__circle-color--${variant}`])} />
                    <div className={classNames(styles['empty-state__circle'], styles['empty-state__circle-2'], styles[`empty-state__circle-color--${variant}`])} />
                    <div className={classNames(styles['empty-state__circle'], styles['empty-state__circle-3'], styles[`empty-state__circle-color--${variant}`])} />
                </button>
            );
        };
        return href ? (
            <AppLink key={`circles-${href}`} href={(href as string)}>
                {circlesButton()}
            </AppLink>
        ) : circlesButton();
    };

    return (
        <div
            className={classNames(styles['empty-state'],
                { 'spacing__window--horizontal': !noPadding },
                { [styles['empty-state__has-background']]: hasBackground },
            )}
            style={verticalMarginsStyle}
        >
            <div className={classNames(styles['empty-state__content-container'])}>
                {renderCirclesIcon()}
                <div className={classNames(styles['empty-state__title'])}>{title}</div>
                <div className={classNames(styles['empty-state__subtitle'])}>{subtitle}</div>
                {actionLabel && href ? (
                    <AppLink key={href} href={(href as string)}>
                        <button
                            type="button"
                            onClick={onPress}
                            className={classNames(styles['empty-state__action-container'])}
                        >
                            <div className={classNames(styles['empty-state__action-label'])}>{actionLabel}</div>
                            <div className={classNames(styles[`empty-state__action-container--${actionIcon}`])}><CustomIcon type={actionIcon} hasIconHover={false} color={variant} /></div>
                        </button>
                    </AppLink>
                ) : actionLabel && onPress ? (
                    <button
                        type="button"
                        onClick={onPress}
                        className={classNames(styles['empty-state__action-container'])}
                    >
                        <div className={classNames(styles['empty-state__action-label'])}>{actionLabel}</div>
                        <div className={classNames(styles[`empty-state__action-container--${actionIcon}`])}><CustomIcon type={actionIcon} hasIconHover={false} color={variant} /></div>
                    </button>
                ) : null}
            </div>
        </div>
    );
}
